import React, { useState } from "react";
import { Box, Modal, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import img1 from "../../assets/ResortGallery/RG1.jpg";
import img2 from "../../assets/ResortGallery/RG2.jpg";
import img3 from "../../assets/ResortGallery/RG3.jpg";
import img4 from "../../assets/ResortGallery/RG4.jpg";
import img6 from "../../assets/ResortGallery/RG5.jpg";
import img5 from "../../assets/ResortGallery/RG6.jpg";
import img7 from "../../assets/ResortGallery/RG7.jpg";
import img8 from "../../assets/ResortGallery/RG8.jpg";
import img9 from "../../assets/ResortGallery/RG9.jpg";
import img10 from "../../assets/ResortGallery/RG10.jpg";
import img11 from "../../assets/ResortGallery/RG11.jpg";
import img12 from "../../assets/ResortGallery/RG12.jpg";
import img13 from "../../assets/ResortGallery/RG13.jpg";



const ImageBox = ({ images, direction = "row", width = "66%", onImageClick, startIndex }) => (
  <Box
    sx={{
      display: "flex",
      flexDirection: direction,
      width: width,
      gap: "20px",
    }}
  >
    {images.map((image, index) => (
      <img
        key={index}
        src={image}
        alt=""
        style={{
          width: "100%",
          height: "auto",
          objectFit: "cover",
          cursor: "pointer",
        }}
        onClick={() => onImageClick(startIndex + index)} // Ensure correct index
      />
    ))}
  </Box>
);


const boxStyles = {
  display: "flex",
  width: "98%",
  maxWidth: "100%",
  margin: "0 auto",
  height: "auto",
  padding: "0 10px",
  gap: "20px",
  marginBottom: "20px",
  boxSizing: "border-box",
};

const LargeScreenImageChart = () => {
  const [open, setOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const images = [img1, img2, img3, img4, img5, img6, img7, img8, img9, img10, img11, img12, img13];

  const handleClose = () => setOpen(false);
  const handleOpen = (index) => {
    setCurrentImageIndex(index);
    setOpen(true);
  };
  const handlePrev = () => {
    setCurrentImageIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };
  const handleNext = () => {
    setCurrentImageIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  return (
    <>
      <Box sx={boxStyles}>
        <ImageBox images={[img1, img2]} direction="column" width="34%" onImageClick={handleOpen} startIndex={0} />
        <ImageBox images={[img3]} onImageClick={handleOpen} startIndex={2} />
      </Box>

      <Box sx={boxStyles}>
        <ImageBox images={[img4]} onImageClick={handleOpen} startIndex={3} />
        <ImageBox images={[img5, img6]} direction="column" width="34%" onImageClick={handleOpen} startIndex={4} />
      </Box>

      <Box sx={boxStyles}>
        <ImageBox images={[img7]} width="100%" onImageClick={handleOpen} startIndex={6} />
      </Box>

      <Box sx={boxStyles}>
        <ImageBox images={[img8, img9]} direction="column" width="34%" onImageClick={handleOpen} startIndex={7} />
        <ImageBox images={[img10]} onImageClick={handleOpen} startIndex={9} />
      </Box>

      <Box sx={boxStyles}>
        <ImageBox images={[img11]} onImageClick={handleOpen} startIndex={10} />
        <ImageBox images={[img12, img13]} direction="column" width="34%" onImageClick={handleOpen} startIndex={11} />
      </Box>

      <Modal open={open} onClose={handleClose} sx={{ backgroundColor: "rgba(128, 128, 128, 0.7)" }}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "80%",
            height: "80%",
            backgroundColor: "transparent",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <IconButton
            onClick={handleClose}
            sx={{
              position: "absolute",
              top: "-50px",
              right: "10px",
              border: "1px solid #E1D9CF",
              backgroundColor: "transparent",
              borderRadius: "0",
            }}
          >
            <CloseIcon sx={{ fontSize: "16px", color: "#E1D9CF" }} />
          </IconButton>
          <Box
            component="img"
            src={images[currentImageIndex]}
            alt={`Image ${currentImageIndex}`}
            sx={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
          <IconButton
            onClick={handlePrev}
            sx={{
              position: "absolute",
              top: "50%",
              left: "10px",
              transform: "translateY(-50%)",
              border: "1px solid #E4CAAE",
              backgroundColor: "transparent",
              borderRadius: "0",
            }}
          >
            <ArrowBackIcon sx={{ fontSize: "16px", color: "#A88765" }} />
          </IconButton>
          <IconButton
            onClick={handleNext}
            sx={{
              position: "absolute",
              top: "50%",
              right: "10px",
              transform: "translateY(-50%)",
              border: "1px solid #E4CAAE",
              backgroundColor: "transparent",
              borderRadius: "0",
            }}
          >
            <ArrowForwardIcon sx={{ fontSize: "16px", color: "#A88765" }} />
          </IconButton>
        </Box>
      </Modal>
    </>
  );
};

export default LargeScreenImageChart;
